import { render, staticRenderFns } from "./DriverLogin.vue?vue&type=template&id=2be30024&scoped=true"
import script from "./DriverLogin.vue?vue&type=script&lang=js"
export * from "./DriverLogin.vue?vue&type=script&lang=js"
import style0 from "./DriverLogin.vue?vue&type=style&index=0&id=2be30024&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be30024",
  null
  
)

export default component.exports